import { createFileRoute, Outlet } from '@tanstack/react-router'

// Layout wrapper for legacy /documents/projects/$projectId route (now redirector)
export const Route = createFileRoute(
  '/_authenticated/_dashboard/documents/projects/$projectId',
)({
  component: () => <Outlet />,
})
